// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__EdQTx","checkbox__input":"styles_checkbox__input__zRh3Z","checkbox__icon":"styles_checkbox__icon__xv6SG"};